import { mapValues, removeWrappingCommas } from '@ps-gui/shared-utils';

import { ExtractedValue, ExtractedValuesByKey } from '../../models/extracted-values';

export const cleanValues = (fields: Partial<ExtractedValuesByKey>): ExtractedValuesByKey =>
  mapValues<string, ExtractedValue, ExtractedValue>(fields, (_, value) =>
    typeof value === 'string' ? removeWrappingCommas(value) : value,
  );
